import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import {
  beneCategories,
  beneViewAllAcc,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { ownerListViewAllAcc } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { scheduleTxnView } from "../../../../redux/features/scheduleTransaction";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import Loader from "../../../../components/Loader/Index";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import ScheduleTransactionViewAllCard from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionViewAllCard";

const ScheduleBeneficiaryTransactionViewSchedules = ({
  isPopup,
  type,
  payload,
  closeCallback,
}) => {
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleClearSearchParam, handleSearchParams } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const lastElementRef = useRef();
  const searchBarRef = useRef(null);
  const clearButtonRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const searchBarContainer = useRef(null);
  const [active, setActive] = useState("");
  const [isPopoverOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingData, setLoadingData] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [txnPayLoadFilter, setTxnPayLoadFilter] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [beneScheduleLoading, setBeneScheduleLoading] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [searchdata, SetsearchData] = useState(searchParam.get("search") || "");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName:
      type === "history" || type === "confidential"
        ? payload.name
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.schedule_acc_name
          : "",
    beneAccountId:
      type === "history" || type === "confidential"
        ? payload.id
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.schedule_acc_id
          : " ",
    bankAccountNo:
      type === "history" ||
      type === "confidential" ||
      type === "scheduleAcc" ||
      type === "ScheduleAccBeneAcc"
        ? payload.number
        : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
          ? payload?.bank_acc_no
          : "",
    bankAccountIFSC: "",

    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });

  const [txnAmountFilter, setTxnAmountFilter] = useState(
    searchParam.get("amount") || "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId
      ? txnPayLoad?.beneAccountId
      : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
        ? payload?.schedule_acc_id
        : "",
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    type === "category" ? payload : searchParam.get("category") || "",
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
      ? "pending"
      : searchParam.get("lifecycle") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    searchParam.get("paymentmethod") || "",
    "",
  );
  const [startDate, setStartDate] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDate, setEndDate] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [FrequencyMethodfilter, setFrequencyMethodfilter] = useState(
    searchParam.get("frequency") || "",
  );
  const [txnPayLoadAccountNameFilter, setTxnPayLoadAccountNameFilter] =
    useState(searchParam.get("sourceAcc") || "");
  const [DestinationAccountName, setDestinationAccountName] = useState(
    type === "history" || type === "confidential"
      ? payload.id
      : type === "scheduleAcc" || type === "ScheduleAccBeneAcc"
        ? payload?.schedule_acc_id
        : searchParam.get("beneAcc") || "",
  );
  const [txnPayLoadDesitinationNameFilter, setTxnPayLoadDestinationNameFilter] =
    useState(
      type === "history" ||
        type === "confidential" ||
        type === "ScheduleAccBeneAcc" ||
        type === "scheduleAcc"
        ? payload.schedule_acc_name
        : "",
    );
  const [confidentialMethod, setConfidentialMethod] = useState(
    type === "confidential" ? "Show only confidential" : "",
  );
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState(
    type === "confidential"
      ? "Show only confidential"
      : searchParam.get("confidential") || "",
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const services = useSelector((state) => state.refreshToken.services);

  const handleCloseViewModal = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    closeCallback?.call();
    setIsViewModalOpen(false);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setAccumulatedData([]);
    toggleDropdown();
  };

  const formatDate = (date) => {
    const day = String(date?.getDate())?.padStart(2, "0");
    const month = String(date?.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    startDateFilter,
    DestinationAccountName,
    initCategoryFilter,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
  ]);

  const fetchScheduleViewAllData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Beneficiary account":
          response = await dispatch(
            beneViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "search":
          if (searchUserTextDebounce === "") {
            SetsearchData("");
          } else {
            SetsearchData(searchUserTextDebounce);
          }
          setBeneScheduleLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          SetsearchData(searchUserTextDebounce);
          setLoadingData(false);

          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchScheduleViewAllData();
    }
  }, [active]);

  const FREQUENCY_MAP = {
    "Once": "once",
    "Daily": "daily",
    "Weekly": "weekly",
    "Fortnightly": "fortnightly",
    "Monthly": "monthly",
    "Quarterly": "quarterly",
    "Half yearly": "half_yearly",
    "Yearly": "yearly",
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleFrequencyMethod = (uiValue) => {
    const apiValue = FREQUENCY_MAP[uiValue] || uiValue.toLowerCase();
    handleSubmit("frequency", apiValue);
    setFrequencyMethodfilter(apiValue);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleAction = async () => {
    try {
      setBeneScheduleLoading(true);

      let queryParams1 = {
        page_no: currentPage,
        page_item_count: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (FrequencyMethodfilter !== "") {
          queryParams1.frequency = FrequencyMethodfilter;
        }

        if (currentStatus) {
          if (currentStatus === "Require approval") {
            queryParams1.lifecycle_status = "pending";
          } else if (currentStatus === "Discarded") {
            queryParams1.lifecycle_status = "deleted";
          } else {
            queryParams1.lifecycle_status = currentStatus;
          }
        }

        if (initCategoryFilter !== null) {
          queryParams1.category = initCategoryFilter;
        }
        if (startDateFilter) {
          queryParams1.transaction_start_date = formatDate(startDateFilter);
        }

        if (endDateFilter) {
          queryParams1.transaction_end_date = formatDate(endDateFilter);
        }
        if (isPaymentMethod && isPaymentMethod !== "All") {
          queryParams1.payment_method = isPaymentMethod;
        }
        if (confidentialMethodFilter !== "") {
          queryParams1.confidential_transaction = confidentialMethodFilter;
        }

        if (txnAmountFilter !== "") {
          queryParams1.amount = txnAmountFilter;
        }

        if (DestinationAccountName !== "") {
          queryParams1.beneficiary_account_id = DestinationAccountName;
        }

        if (txnPayLoadAccountNameFilter !== "") {
          queryParams1.owner_account_id = txnPayLoadAccountNameFilter;
        }
        if (searchdata !== "") {
          queryParams1.scheduled_name = searchdata;
        }
      };

      addParamsBasedOnSelection();

      const response = await dispatch(scheduleTxnView(queryParams1));

      setMainData(response?.payload);
      setBeneScheduleLoading(true);
      const newData = response?.payload?.transactions || [];
      setAccumulatedData(newData);
    } catch (error) {
      setAccumulatedData([]);
    } finally {
      setBeneScheduleLoading(false);
    }
  };

  const onMount = () => {};

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [dispatch]);

  useEffect(() => {
    onMount();
  }, [markerData]);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    currentPage,
    pageSize,
    isPaymentMethod,
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    currentStatus,
    startDateFilter,
    DestinationAccountName,
    initCategoryFilter,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
  ]);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        FrequencyMethodfilter !== "" ||
        confidentialMethodFilter !== "" ||
        txnPayLoadFilter !== "" ||
        txnPayLoadDesitinationNameFilter !== "" ||
        searchdata !== "" ||
        initCategoryFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter !== "" ||
        DestinationAccountName !== "" ||
        txnPayLoadAccountNameFilter !== "",
    );
  };
  useEffect(() => {
    updateIsFilterApplied();
  }, [
    FrequencyMethodfilter,
    isPaymentMethod,
    confidentialMethodFilter,
    txnPayLoadFilter,
    txnPayLoadDesitinationNameFilter,
    initCategoryFilter,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    searchdata,
    DestinationAccountName,
    txnPayLoadAccountNameFilter,
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const isInsideSearch =
        searchBarContainer.current &&
        searchBarContainer.current.contains(e.target);
      const isInsideToggle =
        searchBarRef.current && searchBarRef.current.contains(e.target);
      const isInsideClear =
        clearButtonRef.current && clearButtonRef.current.contains(e.target);

      if (
        showSearchBar &&
        !isInsideSearch &&
        !isInsideToggle &&
        !isInsideClear
      ) {
        setShowSearchBar(false);
        setShowInnerSearchBar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showSearchBar]);

  const statuses = [
    "approved",
    "Require approval",
    "pending",
    "rejected",
    "Discarded",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasABeneficiary = services?.includes("ABeneficiaryTxn");
    const hasCBeneficiary = services?.includes("CBeneficiaryTxn");

    const beneficiaryTxn =
      hasCBeneficiary &&
      !hasABeneficiary &&
      !hasAdmin &&
      status === "Require approval";

    const beneScheduleTxn =
      hasABeneficiary && !hasCBeneficiary && !hasAdmin && status === "pending";

    if (beneficiaryTxn) {
      return false;
    }

    if (beneScheduleTxn) {
      return false;
    }

    if (hasAdmin && hasABeneficiary && hasCBeneficiary) {
      return true;
    }

    return true;
  });

  const handleSubmit = (key, value) => {
    if (
      type !== "history" &&
      type !== "scheduleAcc" &&
      type !== "confidential"
    ) {
      handleSearchParams(key, value);
    }
  };

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [currentPage, accumulatedData]);

  return (
    <>
      <div
        className={`overflow-y-hidden ${type === "ScheduleAccBeneAcc" ? "relative h-full overflow-x-hidden" : " h-full-height"} flex flex-col bg-primary-bg ${isPopup ? "h-height-full" : !accumulatedData?.length ? "" : ""}`}
      >
        {!beneScheduleLoading &&
          accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
            <div
              className={`w-width-full  z-z-index-modal ${type === "ScheduleAccBeneAcc" ? " absolute" : "fixed h-pagination-height"} ${(showInnerSearchBar || isPopoverOpen) && "pointer-events-none"} ${
                isPopup
                  ? "w-width-full Qsmd:w-[96%] bottom-bottom-base Qsmd:bottom-[4%] Qsmd:rounded-b-border-radius-md"
                  : "bottom-bottom-base"
              }
              ${type === "scheduleAcc" ? "h-auto Qmd:h-status_all_height" : "h-pagination-height"}
              ${type === "scheduleAcc" ? "block" : `block  ${type === "scheduleAcc" ? "rounded-b-border-radius-md" : ""}`}`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                payload={payload}
                setIsOpen={setIsOpen}
                type={type === "scheduleAcc" ? "scheduleAcc" : ""}
                typePopup={isPopup}
              />
            </div>
          )}

        <div
          className={`bg-primary-nav ${isPopup ? "" : type === "ScheduleAccBeneAcc" ? "" : "Qsmd:h-navbar-breadcrumb-height "}`}
        ></div>

        <TopNavComponent
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            showSearchBar: showSearchBar,
            isSearchDisabled: beneScheduleLoading,
            onSearchInput: handleSearch,
            searchText: searchUserTextDebounce,
            searchPlaceholder: "Search schedule beneficiary transaction",
            filterPlaceholder: "Schedule name",
            filterItems: [
              {
                name: "Search",
                isMulti: false,
                value: searchdata,
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("search", val);
                  SetsearchData(val);
                },
                isDropdown: false,
                isDisabled: beneScheduleLoading,
              },
              {
                name: "Owner account",
                short_name: "Own A/c",
                isMulti: false,
                value: txnPayLoadAccountNameFilter,
                displayValue: standardAccountNumberFormat(accountNumber, true),
                setValue: (val) => {
                  handleSubmit("sourceAcc", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnPayLoadAccountNameFilter(val);
                },
                setDisplayValue: setAccountNumber,
                valueType: "string",
                isDropdown: true,
                isDisabled: beneScheduleLoading,
              },
              {
                name: "Beneficiary account",
                short_name: "Bene. Acc",
                isMulti: false,
                value: DestinationAccountName,
                displayValue:
                  accountName
                    ?.toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ") ||
                  accountNameValue
                    ?.toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "),
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("beneAcc", val);
                  setDestinationAccountName(val);
                },
                setDisplayValue: (val) => {
                  setAccountName(val);
                  setAccountNameValue(val);
                },
                isDropdown: true,
                valueType: "string",
                isDisabled: beneScheduleLoading
                  ? true
                  : type === "history" ||
                    type === "scheduleAcc" ||
                    type === "confidential" ||
                    type === "ScheduleAccBeneAcc",
              },
              {
                name: "Category",
                valueType: "string",
                short_name: "Cat",
                isMulti: false,
                value: initCategoryFilter,
                setValue: (val) => {
                  handleSubmit("category", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setInitCategoryFilter(val);
                },
                isDropdown: true,
                isDisabled: beneScheduleLoading ? true : type === "category",
              },
              {
                name: "Amount",
                short_name: "Amt - INR",
                isMulti: false,
                value: txnAmountFilter,
                setValue: (val) => {
                  handleSubmit("amount", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnAmountFilter(val);
                },
                displayValue: FormatAmount({
                  price: txnAmountFilter,
                }),
                isDropdown: false,
                isDisabled: beneScheduleLoading,
                valueType: "number",
              },
            ],
            filters: [
              {
                name: "Approval status",
                filterType: "dropdown",
                variant: "single",
                value: currentStatus,
                options: filteredStatuses.map((status) => status),
                dropdownPlaceHolder:
                  currentStatus === "deleted"
                    ? "Discard"
                    : currentStatus === "rejected"
                      ? "Rejected"
                      : "Select status",
                isDisabled: type === "ScheduleAccBeneAcc" ?? false,
                statusPop: true,
                handleChange: (val) => {
                  handleSubmit("lifecycle", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setCurrentStatus(val);
                },
              },
              {
                name: "Frequency",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: [
                  "Once",
                  "Daily",
                  "Weekly",
                  "Fortnightly",
                  "Monthly",
                  "Quarterly",
                  "Half yearly",
                  "Yearly",
                ],
                searchPlaceholder: "Search",
                dropdownPlaceHolder: "Select frequency",
                value:
                  Object.keys(FREQUENCY_MAP).find(
                    (key) => FREQUENCY_MAP[key] === FrequencyMethodfilter,
                  ) || FrequencyMethodfilter,
                isDisable: false,

                handleChange: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleFrequencyMethod(val);
                },
              },
              {
                name: "Schedule start date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: startDateFilter,
                startDate: startDate,
                handleChange: (value) => {
                  handleSubmit("startDate", value);

                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setStartDate(value);
                  setStartDateFilter(value);

                  if (endDate && new Date(value) > new Date(endDate)) {
                    setEndDate("");
                    setEndDateFilter("");
                    handleSubmit("endDate", "");
                  }
                },
                minDate: null,
                maxDate: null,
              },
              {
                name: "Show/hide confidential schedules",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["Show only confidential", "Hide confidential"],
                searchPlaceholder: "Search",
                isDisabled: type === "confidential",
                dropdownPlaceHolder:
                  confidentialMethod &&
                  confidentialMethod !== "Default (all schedules)"
                    ? confidentialMethod
                    : "Default (all schedules)",
                value: confidentialMethodFilter,
                handleChange: (val) => {
                  handleSubmit("confidential", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleConfidentialMethod(val);
                },
              },
              {
                name: "Payment method",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["NEFT", "RTGS"],
                searchPlaceholder: "Search",
                dropdownPlaceHolder:
                  paymentMethod === "" ? "Select type" : paymentMethod,
                value: isPaymentMethod,
                dropdownType: "PaymentMethod",
                isDisable: false,
                handleChange: (val) => {
                  handleSubmit("paymentmethod", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handlePaymentMethod(val);
                },
              },
              {
                name: "Schedule end date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: endDateFilter,
                startDate: endDate,
                handleChange: (value) => {
                  handleSubmit("endDate", value);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setEndDate(value);
                  setEndDateFilter(value);

                  if (startDate && new Date(value) < new Date(startDate)) {
                    setStartDate("");
                    handleSubmit("startDate", "");
                    setStartDateFilter("");
                  }
                },
                minDate: startDateFilter || new Date(),
                maxDate: null,
              },
            ],

            isFilterClearAllDisabled: !(
              isPaymentMethod?.length ||
              FrequencyMethodfilter?.length ||
              (type !== "confidential" && confidentialMethodFilter?.length) ||
              startDateFilter ||
              endDateFilter ||
              currentStatus?.length ||
              beneScheduleLoading
            ),

            isSearchClearAllDisabled: !(
              (type !== "category" && initCategoryFilter?.length) ||
              (type !== "history" &&
                type !== "confidential" &&
                type !== "scheduleAcc" &&
                type !== "ScheduleAccBeneAcc" &&
                DestinationAccountName?.length) ||
              searchdata?.length ||
              txnAmountFilter?.length ||
              (type !== "history" &&
                type !== "confidential" &&
                txnPayLoadAccountNameFilter?.length) ||
              beneScheduleLoading
            ),

            inputData: inputData,
            active: active,
            setActive: setActive,
            beneScheduleLoading: loadingData,
            setBeneScheduleLoading: setLoadingData,
            isShowFilter: true,
            loading: beneScheduleLoading,
            loadingData: loadingData,

            isSortDisabled: beneScheduleLoading,
            isFilterDisabled: beneScheduleLoading,
          }}
          BottomSubText={
            "Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
          }
          BottomSubTextVaraint="primary"
          ispagination={
            accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
              ? false
              : true
          }
        />

        <div className="beneTxnViewAll_middle_section_container mx-auto webViewRejectAll"></div>
        <div
          // ref={scrollContainerRef}
          className={`flex flex-col flex-1 relative items-center ${accumulatedData?.length > GlobalConfiguration.lengthCheckZero && !beneScheduleLoading && "mb-[var(--pagination-height)]"} overflow-hidden  ${!accumulatedData?.length && "justify-center"} `}
          style={{
            opacity:
              isPopoverOpen || showInnerSearchBar
                ? "var(--dark-opacity)"
                : "var(--base-opacity)",
            backgroundColor:
              isPopoverOpen || showInnerSearchBar
                ? "var(--PopUp-BackDrop)"
                : "",
            paddingTop:
              !showSearchBar &&
              isFilterApplied &&
              !accumulatedData.length &&
              isPopup &&
              !hideCarousal
                ? "var(--padding-md)"
                : isFilterApplied && !accumulatedData.length && isPopup
                  ? "var(--padding-md)"
                  : "",
          }}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col items-center w-full z-z-index-base flex-1 h-height-full opacity-base-opacity"
            style={{
              pointerEvents:
                isSidebarOpen ||
                isPopoverOpen ||
                isViewModalOpen ||
                showInnerSearchBar
                  ? "none"
                  : "",
            }}
          >
            {beneScheduleLoading ? (
              <div className="loader-container m-auto justify-center items-center flex w-width-full h-full-height">
                <Loader />
              </div>
            ) : accumulatedData?.length >
              GlobalConfiguration?.lengthCheckZero ? (
              <div
                className={`flex flex-col min-h-height-base flex-1 w-width-full h-height-full overflow-y-auto scroll-py-top_md ${
                  type === "scheduleAcc" ? "overflow-scroll no-scrollbar" : ""
                } `}
                ref={scrollContainerRef}
              >
                <ScheduleTransactionViewAllCard
                  filterRef={scrollContainerRef}
                  hoverHeight={
                    GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                  }
                  data={accumulatedData}
                  lastElementRef={lastElementRef}
                  isSidebarOpen={isSidebarOpen}
                  numberOfPages={totalPages}
                  isCardHovered={isCardHovered}
                  setIsCardHovered={setIsCardHovered}
                  isPopoverOpen={isPopoverOpen}
                  currentStatus={currentStatus}
                  onClose={handleCloseViewModal}
                  type={type}
                />
              </div>
            ) : accumulatedData?.length ===
              GlobalConfiguration?.lengthCheckZero ? (
              <div
                className={
                  isPopoverOpen || showInnerSearchBar
                    ? `h-height-full flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                    : isPaymentMethod !== "" ||
                        FrequencyMethodfilter !== "" ||
                        confidentialMethodFilter !== "" ||
                        txnPayLoadFilter !== "" ||
                        initCategoryFilter ||
                        startDateFilter ||
                        endDateFilter ||
                        txnAmountFilter !== "" ||
                        txnPayLoadDesitinationNameFilter !== ""
                      ? `h-height-full flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                      : "flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm"
                }
              >
                <img
                  src={
                    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  }
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className={"text-font-sm text-text-primary items-center"}>
                  No data found.
                </p>

                <div
                  style={{
                    display:
                      isFilterApplied ||
                      isPaymentMethod?.length ||
                      FrequencyMethodfilter?.length ||
                      confidentialMethodFilter?.length ||
                      txnPayLoadFilter.length ||
                      initCategoryFilter?.length ||
                      startDateFilter?.length ||
                      endDateFilter?.length ||
                      txnAmountFilter?.length ||
                      txnPayLoadDesitinationNameFilter?.length ||
                      currentStatus?.length ||
                      searchdata?.length ||
                      DestinationAccountName?.length ||
                      startDate ||
                      endDate
                        ? "flex"
                        : "none",
                  }}
                >
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearSearchParam();
                      SetsearchData("");
                      setFrequencyMethodfilter("");
                      setTxnPayLoadFilter("");
                      if (type === "scheduleAcc") {
                        setTxnPayLoad((prev) => ({
                          ...prev,
                          ownerbankAccountNo: "",
                        }));
                      }
                      setStartDate(null);
                      setStartDateFilter("");
                      setEndDate(null);
                      setEndDateFilter("");
                      setTxnPayLoadAccountNameFilter("");
                      setTxnPayLoadDestinationNameFilter("");
                      type !== "category" && setInitCategoryFilter("");
                      setIsPaymentMethod("");
                      setPaymentMethod("");
                      setTxnAmountFilter("");
                      setTxnPayLoad({
                        ...txnPayLoad,
                        amount: "",
                      });
                      type !== "confidential" &&
                        setConfidentialMethodFilter("");
                      type !== "confidential" && setConfidentialMethod("");

                      type !== "history" &&
                        type !== "confidential" &&
                        type === "scheduleAcc" &&
                        setTxnPayLoadDestinationNameFilter("");

                      type !== "history" &&
                        type !== "confidential" &&
                        setTxnPayLoad((prev) => ({
                          ...prev,
                          bankAccountNo: "",
                        }));
                      if (type !== "ScheduleAccBeneAcc") {
                        setDestinationAccountName("");
                        setCurrentStatus("");
                      }
                    }}
                    buttonRef={clearButtonRef}
                    hoverOption="white"
                  />
                </div>
              </div>
            ) : (
              <div
                className="flex flex-col items-center justify-center m-auto h-height-full"
                style={{
                  opacity:
                    isSidebarOpen || isPopoverOpen || showInnerSearchBar
                      ? "var(--light-opacity)"
                      : "var(--base-opacity)",
                }}
              >
                <img
                  src={
                    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  }
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className={"text-font-sm text-text-primary items-center"}>
                  No data found.
                </p>
                <div
                  style={{
                    display:
                      isFilterApplied ||
                      isPaymentMethod?.length ||
                      FrequencyMethodfilter?.length ||
                      confidentialMethodFilter?.length ||
                      txnPayLoadFilter.length ||
                      initCategoryFilter?.length ||
                      startDateFilter?.length ||
                      endDateFilter?.length ||
                      txnAmountFilter?.length ||
                      txnPayLoadDesitinationNameFilter?.length ||
                      currentStatus?.length ||
                      searchdata?.length ||
                      DestinationAccountName?.length ||
                      startDate ||
                      endDate
                        ? "flex"
                        : "none",
                  }}
                >
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearSearchParam();
                      SetsearchData("");
                      setFrequencyMethodfilter("");
                      setTxnPayLoadFilter("");
                      if (type === "scheduleAcc") {
                        setTxnPayLoad((prev) => ({
                          ...prev,
                          ownerbankAccountNo: "",
                        }));
                      }
                      setStartDate(null);
                      setStartDateFilter("");
                      setEndDate(null);
                      setEndDateFilter("");
                      setTxnPayLoadAccountNameFilter("");
                      setTxnPayLoadDestinationNameFilter("");
                      type !== "category" && setInitCategoryFilter("");
                      setIsPaymentMethod("");
                      setPaymentMethod("");
                      setTxnAmountFilter("");
                      setTxnPayLoad({
                        ...txnPayLoad,
                        amount: "",
                      });
                      type !== "confidential" &&
                        setConfidentialMethodFilter("");
                      type !== "confidential" && setConfidentialMethod("");

                      type !== "history" &&
                        type !== "confidential" &&
                        type === "scheduleAcc" &&
                        setTxnPayLoadDestinationNameFilter("");

                      type !== "history" &&
                        type !== "confidential" &&
                        setTxnPayLoad((prev) => ({
                          ...prev,
                          bankAccountNo: "",
                        }));
                      if (type !== "ScheduleAccBeneAcc") {
                        setDestinationAccountName("");
                        setCurrentStatus("");
                      }
                    }}
                    buttonRef={clearButtonRef}
                    hoverOption="white"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ScheduleBeneficiaryTransactionViewSchedules;
